<template lang="pug">
  .container-listagem
    el-row
      el-col
        Pesquisa(
          placeHolder = "Informe o nome da Gleba ou nº do Processo",
          @search="handlePesquisa"
          @resetSearch="resetPesquisa"
          :cardStyle="{margin:'0px 0px 10px 0px', 'border-radius':'12px'}"
        )
    el-card.default-card(shadow="hover")
      app-divider-refresh-button(
        label="Listagem de Processos",
        @click="resetPesquisa",
        :hasButton="true"
        content="Atualizar processos"
      )

      el-table.table(:data="processosCadastrados" @sort-change='sortChanged')
        template(slot="empty") Não há registros.
        el-table-column(
          prop='numeroProcesso'
          label='Processo',
          width="auto"
          :formatter="Utils.formatEmptyRow"
          sortable='custom'
        )
        el-table-column(
          prop='cadastroColetivo.pecaTecnica.gleba'
          label='Gleba',
          width="auto"
          :formatter="Utils.formatEmptyRow"
          sortable='custom'
        )
        el-table-column(
          prop='cadastroColetivo.pecaTecnica.municipios'
          label='Município',
          width="auto"
          :formatter="formatMunicipio"
          sortable='custom'
        )
        el-table-column(
          prop='statusName'
          label='Situação',
          :formatter="Utils.formatEmptyRow"
          width="auto"
          sortable='custom'
        )
        el-table-column(
          label='Ações',
          width='120'
        )
          template(slot-scope='scope')
            button-acoes(:acoes="botoesAcao(scope.row)")

      app-paginacao(
        :total="totalCadastros"
        :pagina="pagina",
        @changePage="changePage"
      )
</template>

<script>
import { mapActions } from 'vuex'
import ButtonAcoes from '@/components/ButtonAcoes'
import AppPaginacao from '@/components/AppPaginacao'
import AppDividerRefreshButton from '@/components/AppDividerRefreshButton'
import statusProcesso from '@/constants/statusProcessoArrecadacao'
import Pesquisa from '@/components/Pesquisa'
import CONFIGS from '@/constants/configs'
import Utils from '@/utils/utils'
import cloneDeep from 'lodash/cloneDeep'

const FILTRO_EMPTY = {
  pagina: 0,
  tamanhoPagina: CONFIGS.TAMANHO_PAGINACAO,
  withoutStatus: ['ARQUIVADO']
}

export default {
  data () {
    return {
      processosCadastrados: [],
      totalCadastros: 0,
      filtro: cloneDeep(FILTRO_EMPTY),
      Utils
    }
  },

  components: {
    ButtonAcoes,
    AppPaginacao,
    AppDividerRefreshButton,
    Pesquisa
  },

  computed: {

    pagina () {
      return this.filtro.pagina + 1
    }

  },

  methods: {
    sortChanged ({ column, prop, order }) {
      if (order === null) {
        this.filtro.ordem = 'numeroProcesso'
        this.filtro.ordemDirecao = 'DESC'
      } else {
        const direcaoMap = {
          'ascending': 'ASC',
          'descending': 'DESC'
        }
        this.filtro.ordem = prop
        this.filtro.ordemDirecao = direcaoMap[order]
      }

      this.getProcessosCadastrados()
    },

    resetPesquisa () {
      this.filtro.pesquisaSimples = ''
      this.changePage(1)
    },

    handlePesquisa (value) {
      this.filtro.pesquisaSimples = value
      this.filtro.simplificado = true
      this.getProcessosCadastrados()
    },

    formatMunicipio (row, column, prop) {
      if (prop) {
        return prop?.length === 0 ? '-' : prop[0].nome
      }

      return '-'
    },

    changePage (newPage) {
      this.filtro.pagina = newPage - 1
      this.getProcessosCadastrados()
    },

    goToArquivar (processo) {
      this.$router.push({
        name: 'GDA/ARQUIVARPROCESSO',
        query: {
          idProcesso: processo.id
        }
      })
    },
    analisarProcesso (processo) {
      this.$router.push({
        name: 'GDA/ANALISEPROCESSO',
        query: {
          idProcesso: processo.id
        }
      })
    },
    botoesAcao (processo) {
      const acoes = []
      const codigo = processo.status
      if (codigo === statusProcesso.EM_ANALISE) {
        acoes.push({
          click: this.analisarProcesso.bind(this, processo),
          icon: 'list',
          title: 'Gerenciar Processo',
          active: true
        })
      }
      /* if (codigo === statusProcesso.AGUARDANDO_ARQUIVAMENTO) {
        acoes.push({
          click: this.goToArquivar.bind(this, processo),
          icon: 'trending_up',
          title: 'Arquivar processo'
        })
      }
      if (codigo === statusProcesso.EM_ARQUIVAMENTO) {
        acoes.push({
          click: this.goToArquivar.bind(this, processo),
          icon: 'edit',
          title: 'Continuar arquivamento'
        })
      } */
      return acoes
    },

    getProcessosCadastrados () {
      this.findProcessosCadastrados(this.filtro).then(response => {
        this.processosCadastrados = response.processosArrecadacao
        this.totalCadastros = response.total
      })
    },

    ...mapActions({
      findProcessosCadastrados: 'processoArrecadacao/find',
      setMainCardVisibility: 'userInterface/setMainCardVisibility'
    })
  },

  created () {
    this.setMainCardVisibility(false)
    this.getProcessosCadastrados()
  }
}

</script>



// WEBPACK FOOTER //
// src/screens/arrecadacao/gda/components/GdaListagem.vue